// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__zXF9y","subTitleBold":"BoxSubTitle_subTitleBold__aGOwa"};